import "core-js/modules/es7.object.values.js";
//
//
//
//
import moment from 'moment';
export default {
  name: 'FibDate',
  props: {
    value: {
      type: [String, Object]
    },
    options: {
      type: [Array, Function]
    }
  },
  computed: {
    locale: function locale() {
      return {
        firstDayOfWeek: 1,
        days: Object.values(this.$t('date.days')),
        daysShort: Object.values(this.$t('date.daysShort')),
        months: Object.values(this.$t('date.months')),
        monthsShort: Object.values(this.$t('date.monthsShort'))
      };
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.primaryColor
      };
    },
    date: function date() {
      if (moment.isMoment(this.value)) {
        return this.value.format('YYYY/MM/DD');
      } else if (moment.isDate(this.value)) {
        return moment(this.value).format('YYYY/MM/DD');
      }

      return this.value;
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    }
  }
};